import React, { useState, useEffect } from "react";
import api from "../Services/api";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { EffectCoverflow, Pagination } from "swiper";
import icoDownload from '../../assets/img/ico-download.svg';
import "./styles.css";

// install Swiper modules
SwiperCore.use([EffectCoverflow, Pagination]);

const Forms = (props: any) => {

	const [forms, setForms] = useState<any[]>([]);


	useEffect(() => {		

		api.get(props.page)
			.then((response) => {
				setForms(response.data.results);
			})
			.catch((err: string) => {
				throw new Error(err);
			});		
	}, [props.page]);


	const setActive = (id: any) => {
		$(".info").removeClass("form-active");
		$("#info_" + id.toString()).addClass("form-active");
	}

	$('.container').off().on('click', function () {
		$(".info").removeClass("form-active");		
	});
	$('.row').off().on('click', function () {
		$(".info").removeClass("form-active");		
	});

	return (
		<>
			{forms?.filter(i => i.Title).length > 0 &&
				<section className="_carousel-posts mb-10 pb-5">
					<div className="container">
						<div className="row">
							<div className="col-md-10 col-lg-8  offset-md-1">
								<h3> {props.title} </h3>
							</div>

							<div className="col-md-10 col-lg-8 offset-md-1">
								<div className="carousel-cr carousel-post-0">

									<div className="swiper-wrapper">
										<Swiper
											// effect={"coverflow"}
											grabCursor={true}

											slidesPerView={"auto"}
											// coverflowEffect={{
											// 	rotate: 100,
											// 	stretch: 50,
											// 	depth: 100,
											// 	modifier: 2,
											// 	slideShadows: false
											// }}
											pagination={false}
											style={{ maxWidth: "45%", maxHeight: "50%", right: "28%" }}
										>
											{forms.map((item: any, index) => (
												item.Title != null ?
													<SwiperSlide key={index}>
														{item.Title != null &&

															<div className="wiper-slide">
																<div className="card-form bg-light ">
																	<div ></div>
																	<div className="card-form__title" style={{ maxHeight: '20%' }}>
																		<h4> {item.Title} </h4>
																	</div>
																	<div className="card-form__desc form-desc" title={item.Descricao} style={{ position: 'relative', top: '-50px' }}>
																		<p>
																			{item.Descricao}
																		</p>

																	</div>
																	<div className="card-comunicado__btn form-btn-url" style={{ position: 'fixed' }}>
																		<a rel="noreferrer" href={item.URL} target="_blank" className="btn btn-primary rounded p-0 btn-100">
																			<img src={icoDownload} alt="Ícone" />
																		</a>
																	</div>
																	{
																		item.Informacoes
																	    && <div className="form-info" onClick={() => setActive(item.ID)}>
																		<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 45 45"><path d="M22.65 34H25.65V22H22.65ZM24 18.3Q24.7 18.3 25.175 17.85Q25.65 17.4 25.65 16.7Q25.65 16 25.175 15.5Q24.7 15 24 15Q23.3 15 22.825 15.5Q22.35 16 22.35 16.7Q22.35 17.4 22.825 17.85Q23.3 18.3 24 18.3ZM24 44Q19.75 44 16.1 42.475Q12.45 40.95 9.75 38.25Q7.05 35.55 5.525 31.9Q4 28.25 4 24Q4 19.8 5.525 16.15Q7.05 12.5 9.75 9.8Q12.45 7.1 16.1 5.55Q19.75 4 24 4Q28.2 4 31.85 5.55Q35.5 7.1 38.2 9.8Q40.9 12.5 42.45 16.15Q44 19.8 44 24Q44 28.25 42.45 31.9Q40.9 35.55 38.2 38.25Q35.5 40.95 31.85 42.475Q28.2 44 24 44ZM24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24ZM24 41Q31 41 36 36Q41 31 41 24Q41 17 36 12Q31 7 24 7Q17 7 12 12Q7 17 7 24Q7 31 12 36Q17 41 24 41Z"/></svg>
																		
																	</div>		
																	}															
																</div>
																<div className="info" id={"info_" + item.ID} >
																		{item.Informacoes}
																</div>
															</div>															
														}
													</SwiperSlide> : ""
											))}

										</Swiper>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			}
		</>
	)
};
export default Forms;






